// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"23eb9ea6","660":"fd55170b","759":"e0057f7e","803":"dbfe55a5"}[chunkId] + ".css";
};